import { render, staticRenderFns } from "./modelThir.vue?vue&type=template&id=3693e89c&scoped=true&"
import script from "./modelThir.vue?vue&type=script&lang=js&"
export * from "./modelThir.vue?vue&type=script&lang=js&"
import style0 from "./modelThir.vue?vue&type=style&index=0&id=3693e89c&lang=scss&scoped=true&"
import style1 from "./modelThir.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3693e89c",
  null
  
)

export default component.exports